import React from 'react';
import './TeamSection.css';
import { FaWhatsapp } from 'react-icons/fa';
import Ceo from"./Images/G_01.png";
import Manish1 from "./Images/Manish1.jpg";
import SalesManager from "./Images/Navneet.jpg";

const teamMembers = [

    {
        name: 'Ms. Abha Pandey',
        role: 'Managing Director / CEO – APTS',
        about: "Leads GLC with strategic vision and direction. Focuses on global expansion, partnerships, and sustainable growth. Ensures all departments align with the company’s long-term mission and global standards.",
        img: Ceo
    },
   
    {
        name: 'Mr. Manish Pandey',
        role: 'Operation Head  – APTS',
        about: "Manages all IT functions at GLC including website development in React, mobile app creation, and digital infrastructure. Leads automation, system integration, and technology-driven solutions to support global operations.",
        img: Manish1,
        isHoverable: true
    },
    {
        name: 'Mr. Navneet Pandey',
        role: 'Sales/Marketing Head – APTS',
        about: "Drives GLC’s international sales and client outreach. Builds brand presence through strategic marketing and trade events. Identifies new market opportunities and maintains strong customer relationships worldwide.",
        img: SalesManager
    }
   


];

const TeamSection = () => (
    <section id="team" className="team-section">
        <div className="team-header">
            <h2>Meet Our Leadership Team</h2>
            <p>Experts driving our global pharmaceutical excellence</p>
        </div>
        <div className="team-grid">
            {teamMembers.map((member, idx) => (
                <div key={idx} className={`team-card ${member.isHoverable ? 'hoverable-card' : ''}`}>
                    {/* ✅ WhatsApp icon in top-right */}
                    {member.isHoverable && (
                        <a
                            href="https://wa.me/919316580274?text=Hello%2C%20I%20have%20a%20tech%20question%20regarding%20GLC%20IT%20services."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="wa-top-icon"
                        >
                            <FaWhatsapp />
                        </a>
                    )}

                    <div className="team-photo">
                        <img src={member.img} alt={member.name} />
                    </div>
                    <h3>{member.name}</h3>
                    <h6>{member.role}</h6>
                    <p>{member.about}</p>

                    {/* ✅ Hover box (if any) */}
                    {member.isHoverable && (
                        <div className="hover-info">
                            <p>Have a tech question or project idea? Feel free to connect via WhatsApp!</p>
                            <a
                                href="https://wa.me/919316580274"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="wa-link"
                            >
                                <FaWhatsapp className="wa-icon" />
                                Contact on WhatsApp
                            </a>
                        </div>
                    )}
                </div>
            ))}
        </div>
    </section>
);

export default TeamSection;
